import { render } from "./App.vue?vue&type=template&id=d343e744&bindings={\"isLogged\":\"options\",\"logout\":\"options\",\"loggedUser\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
script.render = render

export default script